module.exports = __webpack_public_path__ + "static/cta-2-moc-1-128e27053dae62f0234d5b608f0cb78b.png";